module.exports = __webpack_public_path__ + "static/media/button-close.e45202f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button-close.svg
// module id = 60
// module chunks = 0